import React from 'react';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import {
    buildSegmentInfo,
    getOfferShiftInfo,
    buildShiftTooltip,
} from '../../App/EmployeeDashboard/Utils/uiGenerators';
import { getAsLongDate, getAsStartAndEndTimeFormat } from '../../../common-client2/src/services/ukgDateTime';
import { ShiftSegmentTypeName } from '../../Enums';

// TODO - Find a better name for this service

/**
 * @typedef {Object} ShiftTime
 * @property {Date} ShiftTime.startDate
 * @property {Date} ShiftTime.endDate
 */


/** @param {ApiManager.Segments[]} segments */
const getBatchOfSegments = (segments) => (<>{segments.map((segment, index) => buildSegmentInfo(segment, index))}</>);

// TODO - Consider the transfer icon when displaying the shiftTime

/**
 * 
 * @param {Shift.ShiftPresentationModel[]} shifts
 * @param {string=} isShowEndOfPeriod
 */
const getBatchOfDateTimesFromShifts = (shifts) => (
    <>
        {shifts.map((s) => {
            const hasTransfer = s.segments?.some(segment => segment.type === ShiftSegmentTypeName.TRANSFER_SEGMENT);
            const TransferIcon = () => hasTransfer ? <CompareArrowsIcon /> : <></>;
            return (
                <div key={`${s.id}-${s.startDateTime}`} className="shiftTime-container">
                    {getAsStartAndEndTimeFormat(s.startDateTime, s.endDateTime)}
                    <TransferIcon />
                </div>
            );
        })}
    </>
);

/**
 * 
 * @param {Shift.ShiftPresentationModel[]} shifts
 * @param {string=} isShowEndOfPeriod
 * @param {string=} dateFormat i.e `h:mmaa`. Default: `MM/dd/yy`
 */
export const getBatchOfDatesAsLong = (shifts) => (
    <>
        {shifts.map((s) => (
            <div key={`${s.id}-${s.startDateTime}`}>
                {getAsLongDate(s.startDateTime)}
            </div>
        ))}
    </>
);

/**
 * Gets the location/job from the first segment
 * @param {Shift.ShiftPresentationModel[]} shifts
 */
const getFirstLocationFromShifts = (shifts = []) => {
    if (!shifts?.length) {
        return '';
    }

    for (const segment of shifts[0].segments) {
        if (segment.shortOrgJobPath) {
            return segment.shortOrgJobPath; 
        }
    }

    return '';
};

// To centralize `Shift` and `ShiftInfo` functionalities here.
// TODO Add all the other shift related ones here, if necessary
export {
    buildSegmentInfo,
    getOfferShiftInfo,
    buildShiftTooltip,
    getBatchOfSegments,
    getFirstLocationFromShifts,
    getBatchOfDateTimesFromShifts,
};

